import { Injectable, Optional, Inject } from '@angular/core';
import { 
  GenericTableTranslations, 
  PartialGenericTableTranslations, 
  GenericTableTranslationInput,
  GenericTableTranslationDictionary
} from './generic-table-translations.interface';
import { DEFAULT_GENERIC_TABLE_TRANSLATIONS } from './generic-table-translations.defaults';
import { GERMAN_GENERIC_TABLE_TRANSLATIONS } from './generic-table-translations.de';
import { GenericTranslationService } from '../../services/generic-translation.service';
import { 
  ComponentConfig, 
  createComponentConfigToken, 
  createConfigProvider 
} from '../../services/translation-config.helper';

/**
 * Configuration for Generic Table translations
 */
export interface GenericTableConfig extends ComponentConfig<GenericTableTranslations> {}

/**
 * Injection token for Generic Table configuration
 */
export const GENERIC_TABLE_CONFIG = createComponentConfigToken<GenericTableTranslations>('GENERIC_TABLE_CONFIG');

/**
 * Service for managing Generic Table translations
 * Extends GenericTranslationService with type aliases for backward compatibility
 */
@Injectable({
  providedIn: 'root'
})
export class GenericTableTranslationService extends GenericTranslationService<GenericTableTranslations> {
  
  constructor(
    @Optional() @Inject(GENERIC_TABLE_CONFIG) config?: GenericTableConfig
  ) {
    super(DEFAULT_GENERIC_TABLE_TRANSLATIONS);
    
    // Register available languages
    this.registerLanguage('de', GERMAN_GENERIC_TABLE_TRANSLATIONS);
    
    // Initialize with config translations if provided
    if (config?.translations) {
      this.setGlobalTranslations(config.translations);
    }
  }
}

/**
 * Provider for global Generic Table configuration
 * Usage in app.module.ts:
 * 
 * providers: [
 *   GenericTableConfigProvider.forRoot({
 *     translations: myTranslations
 *   })
 * ]
 */
export const GenericTableConfigProvider = createConfigProvider<GenericTableTranslations>(GENERIC_TABLE_CONFIG);
